<template>
    <div style="min-height: 90vh;">
        <div class="d-flex justify-content-center" style="font-size: 1.1rem; gap:5px; margin-bottom: 2rem; flex-wrap: wrap;">
            <span>Checking in for : </span>
            <span style="font-weight: bold;">{{ checkpoint ? checkpoint.name : '' }}</span>
        </div>
        <p class="d-flex justify-content-center">Scan badge to begin checkin</p>
        <div v-if="attendees.length">
            <div  class="d-flex align-items-center mb-4">
                <el-button class="d-flex align-items-center" @click="rescan">
                    <svg style="width: 16px; height:16px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                    </svg>
                    <span class="ml-2">Rescan</span>
                </el-button>
            </div>
    
            <div>
                <div v-if="attendees.length" v-for="(reg, idx) in attendees">
                    <div>
                        <label style="width: max-content;" class="d-flex align-items-center my-4" :for="idx + reg._id" :disabled="reg.checkpoints[id]" :key="idx + reg._id">
                            <span class="hidden">{{ setTicks(idx, reg.checkpoints[id]) }}</span>
                            <div style="position: relative; display: flex; align-items: center;">
                                <label class="checkbox-container m-0">
                                    <input type="checkbox" :disabled="reg.checkpoints[id]" v-model="ticks[idx]" @change="toggleSelectAttendees(reg, ticks[idx])" :id="idx + reg._id">
                                    <span class="checkmark" :disabled="reg.checkpoints[id]">
                                        <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <path class="checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            <p :style="reg.checkpoints[id] ? 'cursor:not-allowed;' : 'cursor: pointer;'" class="m-0 ml-3 d-flex align-items-center">
                                <span :style="reg.checkpoints[id] ? 'font-size: 1.1rem; color:#d3d3d3;':'font-size: 1.1rem;'">{{ reg | registrationName }}</span>
                                <span style="font-weight: lighter; font-size: x-small;" class="ml-1" v-if="reg.checkpoints[id]">(Checked in)</span>
                            </p>
                        </label>
                    </div>
                    <CheckinDataForm 
                        class="border p-4"
                        v-if="ticks[idx]" 
                        :checkpoint="checkpoint" 
                        :fields="fieldsPerRegistration[reg._id]" 
                        :registration="reg"
                        @change="handleCheckpointFieldDataChange"
                    />
                </div>
            </div>

            <el-button :loading="loading" v-if="attendees.length" style="width: 100%" class="btn btn-primary" @click="checkin">
                {{ selectedAttendees.length ? 'Checkin & Update' : needsSavingFields ? 'Update' : 'Checkin' }}
            </el-button>
        </div>
        <div v-else>
            <div v-if="!processingQr">
                <QrScanner @onDecode="handleDecoded" />
                <p class="d-flex justify-content-center mt-2" style="color: gray;">Switch camera here if needed</p>
            </div>
            
            <div class="d-flex justify-content-center py-4" v-else>
                <Loading />
            </div>
        </div>
        <!-- <el-button @click="handleDecoded('1302')">click</el-button> -->
    </div>
</template>

<script>
import http from "../../http.js";
import { mapState } from 'vuex';
import QrScanner from "../../components/QrScanner.vue"
import Loading from "../Loading.vue";
import CheckinDataForm from "../../components/CheckinDataForm.vue"
export default {
    components: { 
        QrScanner, 
        Loading,
        CheckinDataForm
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            registrationId: null,
            attendees: [],
            selectedAttendees: [],
            ticks: [],
            loading: false,
            processingQr: false,
            checkpoint: null,

            checkpointFields: [],
            fieldDatas: [],
            fieldsPerRegistration: {},
            recordedCheckpointFieldData: [],
            needsSavingFields: false,
            fieldsToShow: []
        }
    },
    computed: {
        ...mapState(['event', 'checkpoints', 'fields']),
    },
    methods: {
        handleCheckpointFieldDataChange(output){
            this.removeCheckpointFieldData(output.registration._id);
            this.recordedCheckpointFieldData.push(output);
            this.needsSavingFields = true
        },
        removeCheckpointFieldData(regId){
            this.recordedCheckpointFieldData = this.recordedCheckpointFieldData.filter(data => data.registration._id != regId);
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        async handleDecoded(data){
            this.registrationId = data;
            this.processingQr = true
            await this.scan()
        },
        setTicks(idx, val){
            if(this.ticks[idx] == undefined) this.ticks[idx] = val
        },
        toggleSelectAttendees(reg, inc) {
            let elIndex = null
            this.selectedAttendees.forEach((el, index) => {
                if (el == reg._id) elIndex = index;
            })
            if (!inc) {
                this.selectedAttendees.splice(elIndex, 1);
                this.removeCheckpointFieldData(reg._id)
            }
            else this.selectedAttendees.push(reg._id)
        },
        async scan() {
            if(!this.registrationId){
                return this.$notify({
                    message: "Registration id or confirmation number is required",
                    type: "danger"
                });
            }
            this.loading = true
            try {
                const res = await http.post('/api/checkpoints/attendees-by-id', { registrationId: this.registrationId, checkpointId: this.id, eventId: this.event._id })
                this.attendees = res.data.registrations.sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
                
                const cf = await http.get(`/api/checkpointfields-data?eventId=${this.$route.params.eventId}&registration=${this.registrationId}`);
                this.fieldDatas = cf.data.data;
                
        
                this.attendees.forEach(reg =>{
                    const fdata =  this.fieldDatas.find(data => data.registration == reg._id);
                    this.fieldsPerRegistration[reg._id] = []
                    this.fieldsToShow.forEach(el =>{
                        el.value = ""
                        if(fdata && fdata.fields.length){
                            fdata.fields.forEach(f =>{
                                if(f._id == el._id){
                                    el.value = f.value
                                }
                            })
                        }
                        if(!el.value){
                            const val = this.getFieldValueFromRegistration(el._id, reg);
                            if(val) el.value = val;
                        }

                        this.fieldsPerRegistration[reg._id].push({...el})
                    })
                })
                
                
                if(res.data.registrations.length == 0){
                    this.$notify({
                        message: "No registrations found",
                        type: "danger"
                    })
                }   
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.loading = false
            this.processingQr = false;
        },
        rescan() {
            this.selectedAttendees = []
            this.attendees = []
            this.ticks = []
            this.registrationId = ""
        },
        async checkin() {
            if(!this.selectedAttendees.length && this.needsSavingFields){
                return await this.updateFields(true);
            }
            this.loading = true
            let primaryRegistrant = (this.attendees.find(el => !el.parent))._id;
            try {
                const res = await http.post('/api/checkpoints/checkin', { 
                    primaryRegistrant, 
                    attendees: this.selectedAttendees, 
                    checkpointId: this.id, 
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.recordedCheckpointFieldData,
                    creator: this.registrationId
                })
                this.$notify({ type: 'success', message: res.data.message })
                this.$router.replace('/success?message=' + res.data.message)
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log(e);
            }
            this.loading = false
        },
        async updateFields(redirect = false){
            try {
                const res = await http.post(`/api/checkpointfields-data/update-fields`, {
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.recordedCheckpointFieldData
                })
                this.$notify(res.data.message);
                if(redirect){
                    this.$router.replace('/success?message=' + res.data.message)
                }
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }

            
        }
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    },
    async mounted(){
        let params = { filters: { eventId: this.$route.params.eventId } }
        
        if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })
        if(!this.checkpoints.length) await this.$store.dispatch('getAll', { path: 'checkpoints', params });

        this.checkpoint = this.checkpoints.find(el => el._id == this.id);

        if(this.$route.query.regNoOrId){
            this.registrationId = this.$route.query.regNoOrId
            this.scan()
        }

        try {
            const res = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`);
            this.checkpointFields = res.data.fields;
        } catch (error) {
            this.$store.dispatch('handleErrors', error);
        }

        this.fields.forEach(el =>{
            if(this.checkpoint.fieldsForCheckinAndAttendeesPage.includes(el._id)){
                el.publicEditable = true
                el.publicView = true
                this.fieldsToShow.push(el)
            }
        });
        
        this.checkpointFields.forEach(el =>{
            if(this.checkpoint.fieldsForCheckinAndAttendeesPage.includes(el._id)){
                this.fieldsToShow.push(el)
            }
        });

        if(this.checkpoint && !this.checkpoint.checkinEnabled) return this.$router.push(`/forbidden/${this.event._id}`)
    }
}


</script>

<style scoped>

/* Hide the default checkbox */
.checkbox-container input {
    display: none;
}
.checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Create a custom checkbox */
.checkbox-container .checkmark {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    border: 0.5px solid rgb(156, 156, 156);
}

/* Hide the SVG checkmark by default */
.checkbox-container .checkmark-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    stroke-width: 5;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 71;
    stroke-dashoffset: 71;
    transition: all 0.3s ease-out;
    opacity: 0;
}

/* Show the SVG checkmark when the checkbox is checked */
.checkbox-container input:checked ~ .checkmark .checkmark-svg {
    stroke-dashoffset: 0;
    opacity: 1;
}
.checkbox-container input:checked ~ .checkmark {
    background: #409EFF;
}
.checkbox-container input:checked ~ .checkmark[disabled] {
    background: #d3d3d3;
    cursor: not-allowed;
}

.idinput{
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: 500px;
    margin: 0 auto;
}

.badge-scanner{
    max-width: 500px;
    margin: 0 auto;
}

.scan-badge-btn{
    width: 100%;
    min-width: max-content;
}

@media screen and (max-width: 500px) {
    .idinput{
        flex-direction: column;
    }
    .proceed-btn{
        width: 100%;
    }
}

</style>